/* eslint-disable sort-keys */
module.exports = {
  defaultLanguage: 'nl_NL',
  langs: ['nl_NL', 'en_GB'],
  alternateLangs: ['en_GB'],
}
